import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw24px =
  'M5.81,22a.83.83,0,0,1-.42-.13A.76.76,0,0,1,5.11,21l3-8H6.94a.76.76,0,0,1-.64-.36.73.73,0,0,1,0-.73l4.5-9a.74.74,0,0,1,.67-.41h6.75a.74.74,0,0,1,.62,1.16L15.09,9.27h3.1a.75.75,0,0,1,.7.47.76.76,0,0,1-.2.83L6.32,21.82A.78.78,0,0,1,5.81,22Zm2.34-10.5h1a.75.75,0,0,1,.61.32.74.74,0,0,1,.09.69L7.6,18.62l8.65-7.85H13.69a.76.76,0,0,1-.63-1.17L16.79,4H11.9Z';

const icons: IconVariations = {
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const BoltIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'bolt'),
) as IconWithRender;

BoltIcon.displayName = 'BoltIcon';
BoltIcon.propTypes = Icon.propTypes;
BoltIcon.renderIcon = (props) => <BoltIcon {...props} />;
export default BoltIcon;
